import { invoiceTriggerTypes, paymentPeriodTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { list as legalPersons } from "sources/books/legalPersons";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    isMain: {
        label: "Основной договор",
        inputProps: { name: "isMain" },
    },
    legalPersonId: {
        // select
        label: "Организация",
        inputProps: { name: "legalPersonId" },
        propName: "name",
        url: legalPersons,
        validators: [requiredField],
        required: true,
    },
    number: {
        label: "Номер договора",
        inputProps: { name: "number" },
        validators: [requiredField],
        required: true,
    },
    date: {
        label: "Дата договора",
        inputProps: { name: "date", type: "date" },
        validators: [requiredField],
        required: true,
    },
    invoiceTriggerType: {
        label: "Основание для выставления счёта",
        inputProps: { name: "invoiceTriggerType" },
        options: invoiceTriggerTypes,
    },
    settlementCurrency: {
        label: "Валюта взаиморасчета",
        inputProps: { name: "settlementCurrency" },
    },
    paymentPeriod: {
        label: "Срок оплаты",
        inputProps: { name: "paymentPeriod", type: "number" },
    },
    paymentPeriodType: {
        label: "Вариант срока оплаты",
        inputProps: { name: "paymentPeriodType" },
        options: paymentPeriodTypes,
    },
    paymentTypeId: {
        label: "Тип оплаты",
        inputProps: { name: "paymentTypeId" },
        dictionary: "paymentType",
    },
    debtCeiling: {
        label: "Лимит задолженности",
        inputProps: { name: "debtCeiling", type: "number" },
    },
    currentDebt: {
        label: "Текущая задолженность",
        inputProps: { name: "currentDebt", type: "number" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
